import React, { useEffect } from 'react'
import { Line } from 'react-chartjs-2'
import '../../../App.scss'
import '../ScenarioStages.scss'
import { connect } from 'react-redux'
import { getPortfolioValuesChartPreviewRequest } from '../../../redux/trainer/trainer.actions'

const PortfoliosValues = ({ getPortfolioValuesChartPreviewRequest, responseGetPortfolioValuesChartPreview, idScenarioPreview }) => {

    useEffect(() => {
        if (idScenarioPreview)
            getPortfolioValuesChartPreviewRequest(idScenarioPreview)
    }, [idScenarioPreview])

    var finalData = []
    if (responseGetPortfolioValuesChartPreview && responseGetPortfolioValuesChartPreview.datasets.length > 0)
        responseGetPortfolioValuesChartPreview.datasets.map(d => {
            finalData.push(
                {
                    label: d.data.name,
                    fill: false,
                    backgroundColor: d.data.color,
                    borderColor: d.data.color,
                    borderWidth: 2,
                    data: d.data.points,
                    hidden: (!d.data.visible),
                    lineTension: 0,
                }
            )
            return finalData
        })

    var state
    if (responseGetPortfolioValuesChartPreview)
        state = {
            labels: responseGetPortfolioValuesChartPreview.labels,
            datasets: finalData
        }

    const options = {
        legend: {
            display: true,
            position: 'bottom',
            labels: {
                fontSize: 11,
                boxWidth: 20,
                boxHeight: 2
            }
        },
        elements: {
            point: {
                radius: 0
            }
        },
        scales: {
            yAxes: [{
                ticks: {
                    fontSize: 11,
                }
            }],
            xAxes: [{
                autoSkip: false,
                ticks: {
                    callback: function (tick, index, ticks) {
                        if (tick % 10 === 0)
                            return tick.toLocaleString();

                        return null;
                    },
                    fontSize: 11,
                }
            }]


        }
    }

    return (
        <div className="general_container stage_container">
            <h4 className="subtitle-stage">Portfolio: Values</h4>
            <Line
                data={state}
                options={options}
            />
        </div>
    )
}

const mapStateToProps = state => ({
    responseGetPortfolioValuesChartPreview: state.trainer.responseGetPortfolioValuesChartPreview,
    idScenarioPreview: state.trainer.idScenarioPreview,
})

const mapDispatchToProps = dispatch => ({
    getPortfolioValuesChartPreviewRequest: payload => dispatch(getPortfolioValuesChartPreviewRequest(payload))
})

export default connect(mapStateToProps, mapDispatchToProps)(PortfoliosValues)